import $ from 'jquery';

import appLib from 'asmag-app-lib';
import user from './user';
import analytics from './analytics';
import i18n from './i18n';
import social from './social';
import issueService from './issueService';
import networkStatusCheck from './networkStatusCheck';
import localStorage from './localStorage';
import upgrades from './upgrades';
import _console from './console';
import registerDevHelper from './issueReaderDevHelper';

class WebApp extends appLib.AppApi {

  constructor() {
    super();

    this.analytics = analytics;

    registerDevHelper( this.issueReaderPluginApi );
  }

  init( siteUrl ) {

    const promise = Promise.resolve( $.get( siteUrl +'/asmag/web-app/env' ) ).
      then( env => {
        this._env = env;
        networkStatusCheck.init();

        return localStorage.init();
      } ).
      then( () => {
        return upgrades.doUpgrades( this.env.system_version );
      } ).
      then( () => {
        analytics.init();

        return Promise.all( [
          user.init().catch( error => this.console.error( error ) ),
          i18n.init( this.env.default_language ).catch( error => this.console.error( error ) )
        ] );
      } ).
      catch( error => {
        this.console.error( error );
      } );

    return promise.then( () => {
      this.hooks.doAction( 'app_initialized' );
      return this;
    } );
  }

  get env() {
    return this._env;
  }

  get appName() {
    return 'web_app';
  }

  get networkStatus() {
    return networkStatusCheck.isOnline;
  }

  set networkStatus( isOnline ) {
    const oldStatus = this.networkStatus;
    networkStatusCheck.isOnline = isOnline;

    if ( isOnline !== oldStatus ) {
      this.hooks.doAction( 'network_status_changed', isOnline );

      if ( isOnline ) {
        this.issueReader.reloadPages();
      }
    }
  }

  get user() {
    return user;
  }

  get i18n() {
    return i18n;
  }

  get social() {
    return social;
  }

  get issueService() {
    return issueService;
  }

  get console() {
    return _console;
  }
}

// This module exports a singleton
export default ( new WebApp() );
